import { ContentType } from '@insided/shared/utils/contentType'
import { OpenEscalationOptions } from '../../Escalation'
import Quote from '../Quote'
import { Author, Reply } from '../../interfaces'
import { ConfigContext } from '../../utils'
import BestAnswer from './BestAnswer'

// eslint-disable-next-line import/no-internal-modules
import Icon from '@insided/deprecated-preact-components/assets'

export interface ReplyContentActionsProps {
  author: Author
  content: string
  topicId: number
  id: string
  contentType: ContentType
  trashed: boolean
  isBestAnswer: boolean
  isPinned: boolean
  likedByOpener: boolean
  likedBy: string[]
  handleTogglePin: () => void
  handleToggleLike: () => void
  onBestAnswerChanged: (answerReply: Reply | null) => void
  isProductboardNoteCreationEnabled: boolean
  isSalesforceCaseEscalationEnabled: boolean
  isZendeskTicketEscalationEnabled: boolean
  isFreshdeskTicketEscalationEnabled: boolean
  isIntercomCreateConversationEnabled: boolean
}

const ReplyContentActions = ({
  author,
  content,
  contentType,
  isBestAnswer,
  isPinned,
  id,
  trashed,
  handleTogglePin,
  handleToggleLike,
  likedByOpener,
  likedBy,
  isProductboardNoteCreationEnabled,
  isSalesforceCaseEscalationEnabled,
  isZendeskTicketEscalationEnabled,
  isFreshdeskTicketEscalationEnabled,
  isIntercomCreateConversationEnabled,
  onBestAnswerChanged,
  topicId
}: ReplyContentActionsProps) => {
  return (
    <ConfigContext.Consumer>
      {({ contentTypeConfig }) => {
        return (
          <footer className='post--options-list'>
            <OpenEscalationOptions
              isProductboardNoteCreationEnabled={isProductboardNoteCreationEnabled}
              isSalesforceCaseEscalationEnabled={isSalesforceCaseEscalationEnabled}
              isZendeskTicketEscalationEnabled={isZendeskTicketEscalationEnabled}
              isFreshdeskTicketEscalationEnabled={isFreshdeskTicketEscalationEnabled}
              isIntercomCreateConversationEnabled={isIntercomCreateConversationEnabled}
              trashed={trashed}
              topicId={parseInt(id)}
              contentType={contentType}
              isReply
            />
            {!trashed &&
              <div className='post--options-list-container'>
                {contentTypeConfig.bestAnswer &&
                  <BestAnswer
                    replyId={id}
                    topicId={topicId}
                    contentType={contentType}
                    isBestAnswer={isBestAnswer}
                    onBestAnswerChanged={onBestAnswerChanged}
                  />}
                {contentTypeConfig.pinReply &&
                  <div className='post--options-list-container-item'>
                    <a data-qa='pin-reply' className='post--options-icon' onClick={handleTogglePin}>
                      <Icon icon='pin' width={16} height={16} />
                      {isPinned ? 'Unpin reply' : 'Pin reply'}
                    </a></div>}
                <div className='post--options-list-container-item'>
                  <a data-qa='like-reply' className={likedByOpener ? 'active' : ''} onClick={handleToggleLike}>
                    <i className='fa fa-thumbs-up' /> Like ({likedBy.length})
                  </a>
                </div>
                <Quote data-qa='quote-reply' content={content} author={author} />
              </div>}
          </footer>
        )
      }}
    </ConfigContext.Consumer>
  )
}

export default ReplyContentActions
